<template>
  <div>
    <h2 class="step-name">Review Calving</h2>

    <div class="step-section">
    </div>

    <div class="step-section">
      <h3>% cows wintered that had assisted calving</h3>
      <bar :chart-data="chartData" :options="chartOptions" ></bar>
    </div>

    <div class="step-section">
      <div class="form-group">
        <label for="calving_keypoints">Key Points</label>
        <textarea rows="5" cols="50" v-model="model.calving_keypoints" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>

      <div class="form-group">
        <label for="calving_actions">Actions</label>
        <textarea rows="5" cols="50" v-model="model.calving_actions" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'
import Bar from '../../charts/Bar'

export default {
  mixins: [ baseComponent ],
  components: {
    Bar,
  },
  data() {
    return {
      model: {
        calving_keypoints: "",
        calving_actions: "",
        CHARTS: {
          assisted_calvings: [],
        },
      },
    }
  },
  computed: {
    chartOptions: function () {
      return {
        title: {
          display: false,
          text: '% cows wintered that had assisted calving'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Percent of CW'
            }
          }]
        }
      }
    },

    chartData: function () {
      return {
        labels: this.model.CHARTS.assisted_calvings.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.assisted_calvings.map(row => parseFloat((row['Percent Total Cows Wintered'] || '').replace('%', ''))).reverse(),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.assisted_calvings.map(row => parseFloat((row['Region Avg. Percent Total Cows Wintered'] || '').replace('%', ''))).reverse(),
          },
        ],
      }
    },
  },
};
</script>
